
import React, { useState, useEffect } from 'react'
import Header from '../../../components/layout/header'
import LeftMenu from '../../../components/layout/leftMenu'
import { ToastContainer, toast } from "react-toastify";
import Switch from "react-switch";
import { FiEdit } from "react-icons/fi";
import { backendApi } from '../../../api/apiService';

function IntervewTypeReport() {

    const [menuClick, setMenuClick] = useState(false);
    const [Data, setData] = useState([]);

    useEffect(() => {
        getAll();
    }, []);

    const getAll = () => {
        var req = {
            functionName: "interviewTypeReport",
            site_id: localStorage.getItem("siteId"),
        };
        backendApi(req).then((response) => {
            console.log('Status Results', response);
            if (response.success == 1) {
                console.log("req", response);
                setData(response.dataSet)
            } else {
                console.log("Error in status viewing.");
                return false;
            }
        });
    };


    const toggleMenu = () => {
        setMenuClick(!menuClick);
    };
    const closeMenu = () => {
        setMenuClick(false);
    };


    return (
        <div className="main-wrapper">
            <div className="top-color"></div>
            <ToastContainer
                enableMultiContainer
                containerId={"D"}
                position="bottom-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
            <div className="content-wrapper">
                <Header
                    Header="Interview Type Report"
                    toggleMenu={toggleMenu}
                    menuClick={menuClick}
                />
                <div className="card main-card">
                    <div className="card-body">
                        <div className="col-md-12">
                            <div className="xilliWrap  table-wrap">
                                <div className="row">
                                    <div className="col-md-8 m-auto">
                                        {/* <div class="text-end mb-3">
                      <button
                        className="btn-btn btn btn-btn2 btn-sm ml-auto"
                        onClick={() => {
                          setDesignationPopup(true);
                          setid("");
                          setEditName("");
                        }}
                      >
                        New Designation
                      </button>
                    </div> */}
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Sl.No</th>
                                                        <th>Type</th>
                                                        <th>Count</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Data.length > 0 ?
                                                        Data.map((status, index) => (
                                                            <tr>
                                                                <td aria-label="Sl.No">{index + 1}</td>
                                                                <td aria-label="Title">
                                                                    {status.interview_type === "" ? "Not Available" : status.interview_type}
                                                                </td>

                                                                <td aria-label="Title">{status.cnt}</td>


                                                            </tr>
                                                        )) : <span className='offset-8' style={{ color: "red" }}>No Data</span>}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>


            </div>
        </div>
    )
}

export default IntervewTypeReport